import SocialIcons from "@/components/layout/footer/social-icons";
import React from "react";
import styles from "./footer.module.scss";
import Link from "next/link";
import horizontalLogo from "@public/horizontal-color-cropped.png";
import Image from "next/image";
import { LINKS } from "@/constants/links.constant";

interface FooterLink {
  name: string;
  url: string;
}

interface LinkColumn {
  columnName: string;
  links: FooterLink[];
}

const navigation: LinkColumn = {
  columnName: "Blessnet",
  links: [
    {
      name: "Home",
      url: LINKS.APP.ROOT,
    },
    {
      name: "Block Scanner",
      url: LINKS.APP.BLOCK_SCANNER,
    },
    {
      name: "Modular Permissions",
      url: LINKS.APP.MOD_PERMS,
    },
    {
      name: "Bridge",
      url: LINKS.APP.BLESS_BRIDGE,
    },
    {
      name: "Bridge Scanner",
      url: LINKS.APP.BRIDGE_SCANNER,
    },
    {
      name: "Ethereals",
      url: LINKS.APP.ETHEREALS,
    },
    {
      name: "Bless Dispenser",
      url: LINKS.APP.DISPENSER,
    },
  ],
};

const docs: LinkColumn = {
  columnName: "Documentation",
  links: [
    {
      name: "Whitepaper",
      url: LINKS.DOC.WHITEPAPER,
    },
    {
      name: "General docs",
      url: LINKS.DOC.GENERAL,
    },
    {
      name: "Technical docs",
      url: LINKS.DOC.TECHNICAL,
    },
    {
      name: "Key apps",
      url: "https://docs.bless.net/getting-started/quickstart#key-apps",
    },
  ],
};

// TODO Add the below links to the links constants file
const info: LinkColumn = {
  columnName: "Info",
  links: [
    {
      name: "Support",
      url: "/support",
    },
    {
      name: "Privacy policy",
      url: "/privacy-policy",
    },
    {
      name: "Terms of service",
      url: "/terms-of-service",
    },
    {
      name: "About",
      url: "/about",
    },
  ],
};

export const footerLinks = [navigation, docs, info];

const Footer = () => {
  return (
    <footer className={styles.footerContainer}>
      <div className={styles.contentWrapper}>
        <div className={styles.left}>
          <div className={styles.logo}>
            <Image src={horizontalLogo} alt="blessnet-logo" width={150} />
          </div>
          <SocialIcons />
          <div className={styles.copyright}>© 2024 All Rights Reserved.</div>
        </div>
        <div className={styles.right}>
          {footerLinks.map((link) => (
            <div key={link.columnName} className={styles.linkColumn}>
              <div className={styles.linkHeader}>{link.columnName}</div>
              <ul className={styles.linkMenu}>
                {link.links.map((link) => (
                  <li key={link.name} className={styles.link}>
                    <Link href={link.url}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
